import React, { useCallback, useMemo } from "react";
import { useActiveGamesProvider } from "../global/activegamesprovider";
import GameGamesList from "../game/gameslist";
import { useSession } from "next-auth/react";
import Game from "../../src/models/game";
import { ApiGame } from "../../src/types/apigame";

export default function HomeLiveGames(): React.ReactNode {
    const { liveGames } = useActiveGamesProvider();
    const { data: session } = useSession();
    const userId = session?.user?.id;

    const isLiveGameViewable = useCallback(
        (game: ApiGame) => {
            const isPlayerInGame = game.seats.some(
                (seatObject) => seatObject.userId === userId,
            );

            if (isPlayerInGame) {
                return true;
            }

            const g = new Game(game);
            const rules = g.getRules();

            return !rules.fog;
        },
        [userId],
    );

    const viewableLiveGames = useMemo(
        (): ApiGame[] => liveGames?.filter(
            (game) => isLiveGameViewable(game),
        ),
        [isLiveGameViewable, liveGames],
    );

    if (!viewableLiveGames || viewableLiveGames.length === 0) {
        return null;
    }

    return <>
        <h1>Live Games:</h1>
        <GameGamesList
            games={viewableLiveGames}
            userId={session?.user?.id}
        />
    </>;
}
